import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routesConfig } from '@src/core/routes';
import { DronesPage, AddDronePage } from './pages';
import { FleetLimitedAccessProvider } from './context/fleet-limited-access-context';

export type FleetFeatureProps = {
  /** Analyst (and similar): list/view only, no add-drone or drone mutations in UI. */
  limitedFleetAccess?: boolean;
};

const FleetFeature: React.FC<FleetFeatureProps> = ({
  limitedFleetAccess = false,
}) => {
  return (
    <FleetLimitedAccessProvider value={limitedFleetAccess}>
      <Routes>
        <Route index element={<DronesPage />} />
        {limitedFleetAccess ? (
          <Route
            path="add-drone"
            element={<Navigate to={routesConfig.fleet} replace />}
          />
        ) : (
          <Route path="add-drone" element={<AddDronePage />} />
        )}
      </Routes>
    </FleetLimitedAccessProvider>
  );
};

export default FleetFeature;